import { style } from '@vanilla-extract/css';

export const tableCell = style({
  width: 'var(--cell-width)',
  backgroundColor: 'var(--wt-table-cell-background-color)',
  borderStyle: 'solid',
  borderColor: 'var(--wt-table-border-color)',
  borderTopWidth: 'var(--wt-table-border-top-width, var(--wt-table-border-width))',
  borderRightWidth: 'var(--wt-table-border-right-width, var(--wt-table-border-width))',
  borderBottomWidth: 'var(--wt-table-border-bottom-width, var(--wt-table-border-width))',
  borderLeftWidth: 'var(--wt-table-border-left-width, var(--wt-table-border-width))',
  paddingTop: 'var(--wt-table-cell-padding-top, var(--wt-table-cell-padding))',
  paddingBottom: 'var(--wt-table-cell-padding-bottom, var(--wt-table-cell-padding))',
  paddingLeft: 'var(--wt-table-cell-padding-left, var(--wt-table-cell-padding))',
  paddingRight: 'var(--wt-table-cell-padding-right, var(--wt-table-cell-padding))',
  fontFamily: 'var(--wt-table-cell-font-family)',
  color: 'var(--wt-table-cell-font-color)',
});
